import React from 'react';
import './TopFold.css';

import Banner from '../components/Banner';



const Header = () => {
  // ... (keep your existing slideshowImages array)


	
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <div>
        <Banner />
      </div>
      <div className="header-content">
        
        <nav className="navigation">
          <ul>
            <li><a href="#home" onClick={() => scrollToSection('home')}>Home</a></li>
            <li><a href="#locations" onClick={() => scrollToSection('locations')}>Locations</a></li>
            <li><a href="#classes" onClick={() => scrollToSection('classes')}>Classes</a></li>
            <li><a href="#about" onClick={() => scrollToSection('about')}>About Us</a></li>
            <li><a href="#contact" onClick={() => scrollToSection('contact')}>Contact</a></li>
           
          </ul>
        </nav>
        <button className="join-button" onClick={() => scrollToSection('contact')}>Contact Us</button>
      </div>
    </header>
  );
};

export default Header;